export function UrgentIcon (props) {
  return (
    <svg
      style={{ verticalAlign: '-webkit-baseline-middle' }}
      width='21px'
      height='21px'
      viewBox='0 0 21 21'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <title>Urgent</title>
      <g
        id='Urgent'
        stroke='none'
        strokeWidth='1'
        fill='none'
        fillRule='evenodd'
      >
        <path
          d='M8.98946125,2.09886042 C9.46434591,1.81689765 10.077892,1.97329175 10.3598547,2.44817641 L10.3598547,2.44817641 L18.1031176,15.4894612 C18.1948511,15.6439597 18.2432629,15.8203203 18.2432629,16 C18.2432629,16.5522847 17.7955476,17 17.2432629,17 L17.2432629,17 L1.75673713,17 C1.57705741,17 1.40069683,16.9515882 1.24619837,16.8598547 C0.771313713,16.577892 0.614919617,15.9643459 0.896882385,15.4894612 L0.896882385,15.4894612 L8.64014526,2.44817641 C8.7255382,2.30435671 8.84564155,2.18425337 8.98946125,2.09886042 Z M9.60693359,13.4077148 C9.30224609,13.4077148 9.05574544,13.4997559 8.86743164,13.6838379 C8.67911784,13.8679199 8.58496094,14.0996094 8.58496094,14.3789063 C8.58496094,14.6582031 8.67911784,14.8888346 8.86743164,15.0708008 C9.05574544,15.2527669 9.30224609,15.34375 9.60693359,15.34375 C9.91585286,15.34375 10.1644694,15.2527669 10.3527832,15.0708008 C10.541097,14.8888346 10.6352539,14.6582031 10.6352539,14.3789063 C10.6352539,14.0953776 10.541097,13.8626302 10.3527832,13.6806641 C10.1644694,13.4986979 9.91585286,13.4077148 9.60693359,13.4077148 Z M10.5123291,6 L8.55725098,6 L8.77307129,12.4047852 L10.2965088,12.4047852 L10.5123291,6 Z'
          id='Combined-Shape'
          fill={props.fill}
        />
      </g>
    </svg>
  )
}
